import {
  type BusinessProfile as BusinessProfileProto,
  BusinessInfo as BusinessInfoProto,
} from '@taxfyle/api-internal/internal/business_profile_pb'
import type { BusinessProfileVersionProps } from '@/features/tax-profile/business-profiles/BusinessProfile'
import { safeTimestampToDate } from '@/utils/grpc-util'
import {
  mapProtoToContactInfo,
  mapContactInfoToProto,
} from '@/features/tax-profile/contact-info-mapper'
import { ContactInfo } from '@/features/tax-profile/ContactInfo'
import {
  BusinessInfo,
  parseDateOfIncorporation,
  formatDateOfIncorporation,
} from '@/features/tax-profile/business-profiles/BusinessInfo'

export function mapBusinessProfileProtoToProps(
  proto: BusinessProfileProto,
): BusinessProfileVersionProps {
  const businessInfoProto = proto.getBusinessInfo()
  const contactInfoProto = proto.getContactInfo()

  return {
    id: proto.getId(),
    version: proto.getVersion(),
    workspaceId: proto.getWorkspaceId(),
    createdAt: safeTimestampToDate(proto.getCreateTime()),
    updatedAt: safeTimestampToDate(proto.getUpdateTime()),
    ownerUserId: proto.getOwnerUserId(),
    contactInfo: contactInfoProto
      ? mapProtoToContactInfo(contactInfoProto)
      : ContactInfo.empty,
    businessInfo: businessInfoProto
      ? mapBusinessInfoProtoToProps(businessInfoProto)
      : BusinessInfo.empty,
  }
}

export function mapBusinessInfoProtoToProps(
  proto: BusinessInfoProto,
): BusinessInfo {
  const dateStr = proto.getDateOfIncorporation()

  return {
    businessName: proto.getBusinessName(),
    dateOfIncorporation: parseDateOfIncorporation(dateStr),
    employerIdentificationNumber: proto.getEmployerIdentificationNumber(),
  }
}

export function mapBusinessInfoToProto(
  businessInfo: BusinessInfo,
): BusinessInfoProto {
  const proto = new BusinessInfoProto()
    .setBusinessName(businessInfo.businessName)
    .setEmployerIdentificationNumber(businessInfo.employerIdentificationNumber)

  if (businessInfo.dateOfIncorporation !== null) {
    proto.setDateOfIncorporation(
      formatDateOfIncorporation(businessInfo.dateOfIncorporation),
    )
  }

  return proto
}

export { mapContactInfoToProto }
